import { VehicleType } from "./../services/vehicleTypeService";
import { lazy } from "react";
import { ROUTES } from "../constants/routes";

/* Lazy pages */
const DashboardPage = lazy(() => import("../pages/Dashboard"));
const Home = lazy(() => import("../pages/Home"));
const Login = lazy(() => import("../pages/Login"));

// Users
const UsersListPage = lazy(() => import("../pages/users/UsersListPage"));
const SendersListPage = lazy(() => import("../pages/users/SendersListPage"));
const CarriersListPage = lazy(() => import("../pages/users/CarriersListPage"));
const NewUsersPage = lazy(() => import("../pages/users/NewUsersPage"));

// Offers (bucketed)
const OffersBucketPage = lazy(() => import("../pages/offers/OffersBucketPage"));

// Misc
const ComplaintsPage = lazy(
	() => import("../pages/ComplaintsPage/ComplaintsPage"),
);
const PopularRoutesPage = lazy(
	() => import("../pages/PopularRoutesPage/PopularRoutesPage"),
);
const ActivityLogPage = lazy(
	() => import("../pages/ActivityLog/ActivityLogPage"),
);
const AdminUsersPage = lazy(
	() => import("../pages/AdminUsers/AdminUsersPage"),
);

export interface AppRoute {
	path: string;
	// eslint-disable-next-line
	component: React.LazyExoticComponent<React.ComponentType<any>>;
	private?: boolean;
}

export const routesConfig: AppRoute[] = [
	// Main
	{ path: ROUTES.DASHBOARD, component: DashboardPage, private: true },
	{ path: ROUTES.HOME, component: Home, private: true },
	{ path: ROUTES.LOGIN, component: Login, private: false },

	// Users
	{ path: ROUTES.TOTAL_USERS, component: UsersListPage, private: true },
	{ path: ROUTES.SENDERS, component: SendersListPage, private: true },
	{ path: ROUTES.CARRIERS, component: CarriersListPage, private: true },
	{ path: ROUTES.USERS_NEW, component: NewUsersPage, private: true }, // expects ?role=&ids=

	// Offers
	{ path: ROUTES.OFFERS_ALL, component: OffersBucketPage, private: true },

	// Misc
	{ path: ROUTES.COMPLAINTS, component: ComplaintsPage, private: true },
	{ path: ROUTES.POPULAR_ROUTES, component: PopularRoutesPage, private: true },
	{ path: ROUTES.ACTIVITY_LOG, component: ActivityLogPage, private: true },
	{ path: ROUTES.ADMIN_USERS, component: AdminUsersPage, private: true },
];
